export const RoutePath = Object.freeze({
    Home: "/expertAssist.html",
    Index: "/index.html",
    Landing: "/",
    All: "*",
});
export type RoutePath = (typeof RoutePath)[keyof typeof RoutePath];
